import $ from 'jquery';

$(document).ready(function() {
    // Добавляем всплывающий блок в body
    $('body').append('<div class="ui-value--product-cashback-notice-tooltip ui-value--product-cashback-notice-tooltip--order">Бонусами можно оплатить до 50% от общей суммы заказа, без учета стоимости доставки. Вы можете использовать любое доступное к списанию количество бонусов при оформлении заказа. <br>1 бонус = 1 рубль</div>');
    $('body').append('<div class="ui-value--product-cashback-notice-tooltip ui-value--product-cashback-notice-tooltip--product">Как использовать бонусы</div>');

    function showTooltip(event, offset,tooltip) {
        let posY = offset.top - 30; // Вычисляем позицию блока по вертикали
        if (tooltip.hasClass('ui-value--product-cashback-notice-tooltip--order')){
            posY = offset.top - 100;
        }

        // Определяем позиционирование по горизонтали
        let posX;
        if (window.innerWidth <= 1600) {
            posX = window.innerWidth - offset.left - $(event.target).outerWidth() - 20; // Используем right
            tooltip.css({
                right: posX + 'px',
                left: 'auto'
            });
        } else {
            posX = offset.left - 106; // Используем left
            tooltip.css({
                left: posX + 'px',
                right: 'auto'
            });
        }

        tooltip.stop(true, true).css({
            top: posY + 'px'
        }).fadeIn();
    }

    // Устанавливаем обработчики событий для настольных устройств
    if (window.innerWidth > 768) {
        $('body').on('mouseenter', '.js-cashback-tooltip-product', function(event) {
            const offset = $(this).offset();
            const productTooltip = $('.ui-value--product-cashback-notice-tooltip--product');
            showTooltip(event, offset,productTooltip);
        });

        $('body').on('mouseleave', '.js-cashback-tooltip-product', function() {
            $('.ui-value--product-cashback-notice-tooltip').delay(500).fadeOut();
        });

        $('body').on('mousemove', '.js-cashback-tooltip-product', function(event) {
            const offset = $(this).offset();
            const productTooltip = $('.ui-value--product-cashback-notice-tooltip--product');
            showTooltip(event, offset,productTooltip);
        });

        $('body').on('mouseenter', '.js-cashback-tooltip-order', function(event) {
            const offset = $(this).offset();
            const orderTooltip = $('.ui-value--product-cashback-notice-tooltip--order');
            showTooltip(event, offset,orderTooltip);
        });

        $('body').on('mouseleave', '.js-cashback-tooltip-order', function() {
            $('.ui-value--product-cashback-notice-tooltip').delay(500).fadeOut();
        });

        $('body').on('mousemove', '.js-cashback-tooltip-order', function(event) {
            const offset = $(this).offset();
            const orderTooltip = $('.ui-value--product-cashback-notice-tooltip--order');
            showTooltip(event, offset,orderTooltip);
        });

        $('.ui-value--product-cashback-notice-tooltip').hover(function() {
            $(this).stop(true, true).fadeIn();
        }, function() {
            $(this).delay(500).fadeOut();
        });
    } else {
        // Устанавливаем обработчики событий для мобильных устройств
        $('body').on('click', '.js-cashback-tooltip-product', function(event) {
            const tooltip = $('.ui-value--product-cashback-notice-tooltip--product');
            const offset = $(this).offset();
            const posY = offset.top - 100;

            let posX = window.innerWidth - offset.left - $(this).outerWidth() - 90; // Используем right для мобильных

            tooltip.stop(true, true).css({
                display: 'block',
                top: posY + 'px',
                right: posX + 'px',
                left: 'auto'
            }).show();
        });

        $('body').on('click', '.js-cashback-tooltip-order', function(event) {
            const tooltip = $('.ui-value--product-cashback-notice-tooltip--order');
            const offset = $(this).offset();
            const posY = offset.top - 115;

            let posX = window.innerWidth - offset.left - $(this).outerWidth() - 210; // Используем right для мобильных

            tooltip.stop(true, true).css({
                display: 'block',
                top: posY + 'px',
                right: posX + 'px',
                left: 'auto'
            }).show();
        });

        $(document).on('click', function(event) {
            if (!$(event.target).closest('.js-cashback-tooltip-order').length &&
                !$(event.target).closest('.ui-value--product-cashback-notice-tooltip').length) {
                $('.ui-value--product-cashback-notice-tooltip').fadeOut();
            }
        });

        $('.ui-value--product-cashback-notice-tooltip').hover(function() {
            $(this).stop(true, true).fadeIn();
        }, function() {
            $(this).delay(500).fadeOut();
        });
    }

});
